<template>
	<div class="d-flex flex-row align-center">
		<v-text-field
			label="杯测地点"
			style="max-width: 20rem"
			v-model="form.location"
			class="mr-2"
			:error-messages="errors.location"
		></v-text-field>
	</div>
	<!-- <div>
		<span v-if="selectedBean">{{ selectedBean.name }}</span>
		<bean-selector @selected="onBeanSelected"></bean-selector>
	</div> -->
	<div class="d-flex flex-row align-center">
		杯测方式：
		<v-radio-group v-model="form.method" inline dense hide-details="auto">
			<v-radio
				v-for="item in refs['CuppingMethod']"
				:key="item.value"
				:label="item.title"
				:error-messages="errors.method"
				:value="item.value"
			></v-radio>
		</v-radio-group>
	</div>
	<div class="d-flex flex-row align-center">
		状态：
		<v-radio-group v-model="form.status" inline dense hide-details="auto">
			<v-radio
				v-for="item in refs['CuppingStatus']"
				:key="item.value"
				:label="item.title"
				:error-messages="errors.status"
				:value="item.value"
			></v-radio>
		</v-radio-group>
	</div>
	<v-textarea v-model="form.description" label="描述" :error-messages="errors.description" rows="2"></v-textarea>

	<!-- Sample Management Section -->
	<div class="mt-4">
		<div class="d-flex align-center mb-2">
			<h3>样本管理</h3>
			<template v-if="!form.id || form.id == ''">保存后可以添加样本</template>
			<v-btn v-else color="primary" @click="addSample">添加熟豆样本</v-btn>
		</div>
		<v-alert v-if="errors.form" type="error" :text="errors.form"></v-alert>
		<v-alert v-if="errors.samples" type="error" :text="errors.samples"></v-alert>
		<v-table v-if="samples && samples.length > 0" density="compact">
			<thead>
				<tr>
					<th class="text-left">豆子</th>
					<th class="text-left">批次</th>
					<th class="text-left">数量(g)</th>
					<th class="text-left">磨豆机/刻度</th>
					<th class="text-left">水温</th>
					<th class="text-left">萃取率</th>
					<th class="text-left">杯测方法</th>
					<th class="text-left">三角杯测标记</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(sample, i) in samples" :key="i">
					<td>{{ sample.bean?.name || '未选择' }}</td>
					<td>{{ sample.beanbatch?.date || '未选择' }}</td>
					<td>{{ sample.beanqty }}</td>
					<td>{{ grindLabel(sample) }}</td>
					<td>{{ sample.watertemp }}</td>
					<td>{{ sample.extractionyield }}</td>
					<td>{{ getMethodLabel(sample.method) }}</td>
					<td>{{ sample.triangle }}</td>
					<td>
						<v-btn @click="editSample(sample)"><v-icon>$edit</v-icon></v-btn>
						<v-btn @click="removeSample(i)" text color="error"><v-icon>$delete</v-icon></v-btn>
					</td>
				</tr>
			</tbody>
		</v-table>
	</div>

	<!-- Sample Dialog -->
	<v-dialog v-model="sampleDialog" max-width="600px">
		<sample-form v-model:value="currentSample" :errors="sampleFormErrors">
			<template #actions="{ object }">
				<v-btn @click="confirmAddSample(object)">确认添加样本</v-btn>
				<v-btn color="secondary" @click="sampleDialog = false">取消</v-btn>
			</template>
		</sample-form>
	</v-dialog>

	<slot name="actions" :object="form"></slot>
</template>

<script>
import BeanSelector from '../bean/Selector.vue'
import SampleForm from './SampleForm.vue'
import { clone } from 'lodash-es'

export default {
	components: { SampleForm, BeanSelector },
	props: {
		value: Object,
		errors: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			form: {},
			refs: {},
			sampleDialog: false,
			currentSample: {},
			beans: [],
			beanBatches: [],
			selectedBean: null,
			selectedBeanBatch: null,
			samples: [],
			sampleFormErrors: {}
		}
	},
	mounted() {
		this.form = clone(this.value)
		this.$api.common.meta('cupping', 'CuppingStatus,CuppingMethod', (res) => {
			this.refs = res
		})
		this.loadSamples()
	},
	watch: {
		value: {
			handler(newVal) {
				this.form = clone(newVal)
				this.loadSamples()
			},
			deep: true
		}
	},
	methods: {
		submitForm() {
			this.$emit('submit', this.form)
		},
		loadSamples() {
			console.log('loadSamples', this.form)
			if (!this.form.id || this.form.id == '') {
				this.samples = this.form.samples
				return
			} else {
				this.$api.cupping.searchSample({ cupping_id: this.form.id }, (res) => {
					this.samples = res.objects
				})
			}
		},
		addSample() {
			this.currentSample = {}
			delete this.currentSample.id
			this.sampleDialog = true
		},
		editSample(sample) {
			this.currentSample = clone(sample)
			this.sampleDialog = true
		},
		confirmAddSample(object) {
			if (!this.form.samples) {
				this.form.samples = []
			}
			let exidx = this.form.samples.findIndex((s) => {
				return s.bean_id === object.bean_id && s.beanbatch_id === object.beanbatch_id
			})
			if (exidx >= 0) {
				if (!confirm('样本(同一豆，相同批次)已存在，是否替换？')) {
					return
				}
			}
			this.$api.cupping.updateSample(
				{
					...object,
					cupping_id: this.form.id
				},
				(res) => {
					this.loadSamples()
					this.sampleDialog = false
				},
				(err) => {
					this.sampleFormErrors = err.data
				}
			)
		},
		removeSample(index) {
			this.form.samples.splice(index, 1)
		},
		getMethodLabel(method) {
			const found = this.refs['CuppingMethod']?.find((m) => m.value === method)
			return found ? found.title : method
		},
		grindLabel(sample) {
			if (!sample) return ''
			const size = sample.grindsize || ''
			const name = sample.grinder_name || ''
			return name ? `${name} ${size}`.trim() : size
		}
	}
}
</script>
